<app-iota-modal [title]="dialogTitle" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body>
        <div class="flex flex-col gap-5 items-center">
            <span *ngIf="isApproveInvoiceDialog" i18n>Do you really want to approve the invoice?</span>
            <span *ngIf="isRejectInvoiceDialog" i18n>Do you really want to reject the invoice?</span>

            <app-note-list
                [notes]="(auditInvoiceSummary$ | ngrxPush)?.invoiceReviewNotes"
                (add)="addNote($event)"
                (delete)="removeNote($event)"
                *ngIf="isShowNotesDialog"
            ></app-note-list>

            <pre class="w-full overflow-x-auto" *ngIf="isShowErrorDialog">{{ (auditInvoiceSummary$ | ngrxPush)?.fullErrorLog }}</pre>

            <div class="alert alert-error shadow-lg" *ngIf="actionError$ | ngrxPush">
                <div class="w-full flex flex-row gap-4">
                    <iota-icon icon="exclamation-triangle" [size]="1.5"></iota-icon>
                    <span *ngIf="isShowNotesDialog" i18n>Error adding/removing note!</span>
                    <span *ngIf="isRejectInvoiceDialog" i18n>Error rejecting invoice!</span>
                    <span *ngIf="isApproveInvoiceDialog" i18n>Error approving invoice!</span>
                </div>
            </div>
        </div>
    </div>

    <div modal-footer class="flex grow justify-between">
        <button class="btn btn-sm btn-ghost rounded-full" (click)="onCancelClick()" i18n>Cancel</button>
        <button
            class="btn btn-sm btn-primary rounded-full"
            [ngClass]="{ loading: actionLoading$ | ngrxPush }"
            (click)="rejectInvoice()"
            *ngIf="isRejectInvoiceDialog"
            i18n
        >
            Reject
        </button>
        <button
            class="btn btn-sm btn-primary rounded-full"
            [ngClass]="{ loading: actionLoading$ | ngrxPush }"
            (click)="approveInvoice()"
            *ngIf="isApproveInvoiceDialog"
            i18n
        >
            Approve
        </button>
    </div>
</app-iota-modal>
